// extracted by mini-css-extract-plugin
module.exports = {"page":"register-confirmation_page__1FKN8","content":"register-confirmation_content__2BqEw","fadeIn":"register-confirmation_fadeIn__3ljMZ"};